import type { Result } from '@cplug/frontend-core/utils'
import type { DataWrappedDTO } from '@cplug/frontend-core/gateways'
import type { SupportChat } from '../models/SupportChat'
import { SupportChatResponseDTO, mapDTOToSupportChat } from './DTOs/SupportChatDTO'
import CPBaseGateway from '~/shared/gateways/CPBaseGateway'

export class CPSupportGateway extends CPBaseGateway {
  protected apiUrlDomain = 'support'

  async getSupportChatData (): Promise<Result<SupportChat>> {
    const response = await this.get<DataWrappedDTO<SupportChat>>(this.apiUrlDomain)

    return this.parseResponse(response, SupportChatResponseDTO, dto => mapDTOToSupportChat(dto.data))
  }
}
